import { Color } from './color'
import { ConfigurationHelper } from './configuration'
import { DateHelper } from './date'
import { DiffHelper } from './diff'
import { Logger } from './logger'
import { RegexHelper } from './regex'
import { TokenHelper } from './token'
import { Utility } from './utility'
import { UtilityItems } from './utilityItems'

export const Toolbox = {
  Utility,
  UtilityItems,
  Date: DateHelper,
  Regex: RegexHelper,
  Token: TokenHelper,
  Diff: DiffHelper,
  Configuration: ConfigurationHelper,
  Logger,
  Color,
}
